import { render, staticRenderFns } from "./deindex.vue?vue&type=template&id=2437e0be&scoped=true"
import script from "./deindex.vue?vue&type=script&lang=js"
export * from "./deindex.vue?vue&type=script&lang=js"
import style0 from "./deindex.vue?vue&type=style&index=0&id=2437e0be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437e0be",
  null
  
)

export default component.exports